import * as PIXI from "pixi.js";
import arrowImage from "../assets/arrow.png";
import { charaSize } from "../constants";
import { LoadManager } from "../managers/loadManager";

export function loadArrowAssets(loadManager: LoadManager) {
  return {
    arrow: loadManager.loadTexture(arrowImage),
  } as const;
}

type SetupArrowProps = Readonly<{
  arrowAssets: ReturnType<typeof loadArrowAssets>;
  parent: PIXI.Container;
  x: number;
  y: number;
  angle: number;
}>;

export function setupArrow({
  arrowAssets,
  parent,
  x,
  y,
  angle,
}: SetupArrowProps) {
  const arrow = new PIXI.Sprite(arrowAssets.arrow.get());
  arrow.width = charaSize * 2;
  arrow.height = charaSize;
  arrow.anchor.set(0.5, 0.5);
  arrow.x = x;
  arrow.y = y;
  arrow.angle = angle;

  parent.addChild(arrow);
  const dispose = () => {
    parent.removeChild(arrow);
  };

  return dispose;
}
